import * as Card from '@/components/ui/card'
import { Heading } from '@/components/ui/heading'
import Disclaimer from '@components/Disclaimer'
import Panel from '@components/Panel'
import { useLastSeen } from '@stateApp'
import type { ParentProps } from 'solid-js'
import { css, cx } from 'styled-system/css'
import { Box, Grid } from 'styled-system/jsx'
import { scrollbar } from 'styled-system/recipes'
import Channels from './Channels'
import Header from './Header'
import Setups from './Setups'

export default function (props: ParentProps) {

  return (
    <Grid gridTemplateRows={'auto 1fr'} gap={0}>
      <Header />

      <Panel
        display='grid'
        gridTemplateColumns={{
          base: '450px 1fr',
          xlDown: '350px 1fr',
          lgDown: '1fr',
        }}
        gap={2}
        pb='0'
      >
        <Box
          class={cx(scrollbar(), css({
            height: {
              base: 'calc(var(--vh) * 100 - 90px)',
            },
            overflow: 'auto',
            display: {
              base: 'grid',
              lgDown: 'none',
            },
            gap: 2,
            alignItems: 'stretch',
          }))}
        >
          <Card.Root p={3}>
            <Heading
              children="Chats"
              textStyle="sm"
              mb='1'
            />
            <Channels />
          </Card.Root>
          <Card.Root p={3}>
            <Heading
              children="Setups"
              textStyle="sm"
              mb='1'
            />
            <Setups />
          </Card.Root>
        </Box>
        {props.children}
      </Panel>
      <Disclaimer />
    </Grid>
  )
}
